<template>
  <v-container>
    <template v-if="loading">
      <v-row justify="start" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
    <template v-else>
      <v-card-title class="pa-5 pb-3">
        <p class="font-weight-bold">メールアドレス変更</p>
      </v-card-title>
      <v-card-text class="pa-5 pt-0">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-form ref="form" v-on:submit.prevent="userEmailUpdate">
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="メールアドレス" rules="required|email|max:255" v-slot="{ errors }">
                  <span class="font-weight-bold">メールアドレス</span>
                  <v-text-field
                    v-model="user.email"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="5">
                <v-btn
                  color="primary"
                  class="button-shadow ma-4 font-weight-bold"
                  width="70%"
                  type="submit"
                  :disabled="invalid"
                >メールアドレスを変更する</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card-text>
        <v-card-title class="pa-5 pb-3">
          <p class="font-weight-bold">パスワード変更</p>
        </v-card-title>
        <v-card-text class="pa-5 pt-0">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-form ref="form" v-on:submit.prevent="userPasswordUpdate">
              <input type="text" name="email" value="" autocomplete="username email" style="display: none;"><!-- Chrome64対策 goo.gl/9p2vKq -->
              <v-row>
                <v-col cols="12" md="5">
                  <ValidationProvider name="現在のパスワード" rules="required|min:8|max:15|passwordRegex" v-slot="{ errors }">
                    <span class="font-weight-bold">現在のパスワード</span>
                    <v-text-field
                      type="password"
                      v-model="old_password"
                      autocomplete="new-password"
                      :error-messages="errors"
                      class="pt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5">
                  <ValidationProvider name="新しいパスワード" rules="required|min:8|max:16|passwordRegex" v-slot="{ errors }">
                    <span class="font-weight-bold">新しいパスワード</span>
                    <v-text-field
                      type="password"
                      v-model="new_password"
                      autocomplete="new-password"
                      :error-messages="errors"
                      class="pt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5">
                  <ValidationProvider name="新しいパスワード（再入力）" rules="required|min:8|max:16|passwordRegex" v-slot="{ errors }">
                    <span class="font-weight-bold">新しいパスワード（再入力）</span>
                    <v-text-field
                      type="password"
                      v-model="new_password_confirmation"
                      autocomplete="new-password"
                      :error-messages="errors"
                      class="pt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5" class="text-center">
                  <v-btn
                    color="primary"
                    class="button-shadow ma-4 font-weight-bold"
                    width="60%"
                    type="submit"
                    :disabled="invalid"
                  >パスワードを変更する</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
    </template>
  </v-container>
</template>
<script>
export default {
  name: 'UserEditAccount',
  data() {
    return {
      selectedItem: 0,
      user: {
        is_released: false,
        user_code: '',
        email: '',
      },
      preview: null,
      old_password: '',
      new_password: '',
      new_password_confirmation: '',
      loading: true,
    };
  },
  computed: {
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    getUserInfo() {
      this.$store.dispatch('userinfo/get', this.getUserCode)
          .then(() => {
            this.user = this.$store.getters['userinfo/getUser']
            this.loading = false
          });
    },
    userEmailUpdate() {
      this.$store.dispatch('userinfo/updateEmail', {email: this.user.email})
          .then(() => {
            this.$swal({
              title: "入力いただいたメールアドレス宛に確認メールをお送りしております。",
              icon: require("@/assets/vla_tips_logo_mini.png"),
            });
            location.reload();
          })
    },
    userPasswordUpdate() {
      this.$store.dispatch('userinfo/updatePassword',{
        old_password: this.old_password,
        new_password: this.new_password,
      })
        .then(() => {
          location.reload();
        })
    },
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user.user_code}})
    }
  },
  created() {
    return this.getUserInfo()
  }
}
</script>